import React from 'react';
import { Calendar, CheckCircle, Headphones } from 'lucide-react';
interface Phase {
  week: string;
  title: string;
  tasks: string[];
  deliverable: string;
}
interface ImplementationSlideProps {
  content: {
    phases: Phase[];
    support: string[];
  };
}
export function ImplementationSlide({
  content
}: ImplementationSlideProps) {
  return <div className="bg-[#F5F5F5] rounded-2xl p-12" data-id="element-120">
      <h2 className="text-4xl font-bold text-[#1C1C1C] mb-4" data-id="element-121">
        30-Day Implementation Roadmap
      </h2>
      <p className="text-xl text-[#4D4D4D] mb-12" data-id="element-122">
        Your path from setup to success
      </p>

      <div className="grid grid-cols-2 gap-6 mb-8" data-id="element-123">
        {content.phases.map((phase, index) => <div key={index} className="bg-white rounded-xl p-6 border-l-4 border-[#0FB07D]" data-id="element-124">
            <div className="flex items-center gap-3 mb-4" data-id="element-125">
              <Calendar className="text-[#0FB07D]" size={24} data-id="element-126" />
              <div data-id="element-127">
                <div className="text-sm font-semibold text-[#017C6D]" data-id="element-128">
                  {phase.week}
                </div>
                <div className="text-xl font-bold text-[#1C1C1C]" data-id="element-129">
                  {phase.title}
                </div>
              </div>
            </div>

            <ul className="space-y-2 mb-4" data-id="element-130">
              {phase.tasks.map((task, idx) => <li key={idx} className="flex items-start gap-2 text-sm text-[#4D4D4D]" data-id="element-131">
                  <CheckCircle size={16} className="text-[#0FB07D] mt-0.5 flex-shrink-0" data-id="element-132" />
                  <span data-id="element-133">{task}</span>
                </li>)}
            </ul>

            <div className="pt-4 border-t border-[#4D4D4D]/10" data-id="element-134">
              <div className="text-xs font-semibold text-[#017C6D] mb-1" data-id="element-135">
                DELIVERABLE
              </div>
              <div className="text-sm font-medium text-[#1C1C1C]" data-id="element-136">
                {phase.deliverable}
              </div>
            </div>
          </div>)}
      </div>

      <div className="bg-gradient-to-r from-[#017C6D] to-[#0FB07D] rounded-xl p-8" data-id="element-137">
        <div className="flex items-center gap-3 mb-6" data-id="element-138">
          <Headphones className="text-white" size={28} data-id="element-139" />
          <h3 className="text-2xl font-bold text-white" data-id="element-140">
            Ongoing Support Included
          </h3>
        </div>
        <div className="grid grid-cols-2 gap-4" data-id="element-141">
          {content.support.map((item, index) => <div key={index} className="flex items-center gap-3 text-white" data-id="element-142">
              <CheckCircle size={20} className="flex-shrink-0" data-id="element-143" />
              <span className="text-lg" data-id="element-144">{item}</span>
            </div>)}
        </div>
      </div>
    </div>;
}
export default ImplementationSlide;